export default __webpack_public_path__ + "static/media/13.5-overlay.ed20a19f.png";